// Essentials
export const BASE_URL = `https://${process.env.VERCEL_PROJECT_PRODUCTION_URL}`
export const PROJECT_NAME = "FartHub"
export const CA = "5S82DHVy5s5TcdaACov9an2qHcP9Z68ZGuNsRDPGpump"
export const TICKER = "$FartHub"
export const PUMP_FUN_LINK = `https://pump.fun/coin/${CA}`
export const PUMP_SWAP_LINK = `https://swap.pump.fun/?input=So11111111111111111111111111111111111111112&output=${CA}`
export const JUPITER_LINK = `https://jup.ag/swap?sell=So11111111111111111111111111111111111111112&buy=${CA}`

export const COIN_GECKO_LINK = `https://www.coingecko.com/en/coins/farthub`
export const COIN_MARKET_CAP_LINK = `https://dex.coinmarketcap.com/token/solana/${CA}/`
export const MEXC_LINK = `https://www.mexc.com/dex/trade?pair_ca=Gk7jWRLXnoZsoVN7WahHSoYm9rC8fT42dDXao6sn39Nz&chain_id=100000&token_ca=${CA}`

// Socials
export const X_LINK = "https://x.com/fhubcto"
export const TELEGRAM_LINK = "https://t.me/farthubcto_portal"
export const DEXSCREENER_LINK =
    "https://dexscreener.com/solana/gk7jwrlxnozsovn7wahhsoym9rc8ft42ddxao6sn39nz"
